import {
  FETCH_EXPENSE_ACCOUNTS_SUCCESS, EDIT_EXPENSE_ACCOUNT, ADD_EXPENSE_ACCOUNT

} from '../actions/expenseAccountActions.js';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_EXPENSE_ACCOUNTS_SUCCESS:
      return action.expense_accounts;
    case EDIT_EXPENSE_ACCOUNT:
      return state.map((expenseAccount) => {
        if (expenseAccount.id === action.id) {
          return {
            ...expenseAccount,
            ...action.updates
          };
        }
        return expenseAccount;
      });
    case ADD_EXPENSE_ACCOUNT:
      return [
        ...state, action.expenseAccount
      ];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/expenseAccountsReducer.js